import { createTranslationsPageProvider } from '@edreamsodigeo/frontend-core';
export const MytripsLoginTranslationsPageProvider = createTranslationsPageProvider({
  supportArea: ({
    brand,
    locale
  }) => import(/* webpackChunkName: "[request]" */`@edreamsodigeo/frontend-support-area/translations/${brand}/${locale}/mytripsLogin`),
  manage_my_booking: ({
    brand,
    locale
  }) => import(/* webpackChunkName: "[request]" */`@edreamsodigeo/frontend-manage-my-booking/translations/${brand}/${locale}/mytripsLogin.js`),
  userAuthentication: ({
    brand,
    locale
  }) => import(/* webpackChunkName: "[request]" */`@edreamsodigeo/frontend-user-authentication/translations/${brand}/${locale}/home.js`)
});